export function updateCriteriaScrollBarVisible()
{
	const windowHeight = $(window).height();
	const areaHeight = $('#searcharea .bg-wrap').height();
	if(windowHeight < areaHeight)
	{
		$('#searcharea').addClass('show-scroll');
	}
	else
	{
		$('#searcharea').removeClass('show-scroll');
	}
}

export function updateExtraSpacerHeight()
{
	let height = 0;
	const windowWidth = $(window).width();
	if( windowWidth < 767)
	{
		if ($('#cookie-notice').length !== 0 && $('#cookie-notice').is(":visible") && $('#cookie-notice')[0].style.cssText.indexOf('visibility: visible') !== -1)
		{
			height = $('#cookie-notice').height();
		}
		let extraHeight = ((siteTmpl === 'tmpl-soeg' && window.location.href.indexOf('?result') !== -1)) ? 32 : 0 ;
		$('.fullSearchSubmitWrapper').attr('style','bottom: '+(height+extraHeight)+'px;');
	}
	else
	{
		$('.fullSearchSubmitWrapper').attr('style','');
	}

	$('#searcharea .extra-spacer').attr('style','height: '+height+'px;');
}
